<!--
 * @Author: your name
 * @Date: 2019-11-11 15:13:03
 * @LastEditTime: 2019-11-14 18:14:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\mainMap\UCOverlay\DrawGeometryOverlay.vue
 -->
<!--  -->
<template>

  <!-- <div
    class="info_container"
    popupshow="true"
  > -->

  <div>
    <div class="title"><span title="标注">{{titleName}}</span></div>
    <div>
      <div class="info_container">
        <div class="edit_content_item">
          <div><span class="edit_label_name">名称</span>
            <textarea
              rows="1"
              id="id_drawItemName"
              name="input"
              v-text="drawItemName"
              class="edit_textarea"
            ></textarea>
          </div>
          <div class="edit_content_item"><span class="edit_label_remark">备注</span> <textarea
              id="id_drawItemRemark"
              placeholder="您最多可以输入200个字"
              maxlength="200"
              name="textarea"
              class="edit_textarea"
              v-text="drawItemRemark"
            ></textarea></div>
        </div>
      </div>
      <div class="edit_btn_group">
        <span style="float: left;font-size: 12px;">{{measureDesc}}</span>

        <a id="id_drawItemDelete">删除</a> 
        
        <a id="id_drawItemSave">保存</a></div>
    </div>
  </div>
  <!---->
  <!-- </div> -->

</template>

<script>
import { DrawGeometry, DrawGeometryType } from "../../model/DrawGeometryJs.js";

export default {
  name: "DrawGeometryOverlay",
  data() {
    return {
      
      curDrawItem: new DrawGeometry(),

      titleName: null,

      drawItemName: null,

      drawItemRemark: null,

      //量测描述
      measureDesc:null,

    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      if (!this.curDrawItem) {
        this.curDrawItem = new DrawGeometry();
      }

      let drawItemDefaultName = null;

      let itemType = this.curDrawItem.type;
      if (itemType === DrawGeometryType.point) {
        drawItemDefaultName = "点标注";
        this.titleName = "点标注";
      } else if (itemType === DrawGeometryType.polyline) {
        drawItemDefaultName = "线标注";
        this.titleName = "线标注";

        let lineLength = this.curDrawItem.getLength();
        if (lineLength > 1000) {
          this.measureDesc =
            "总长度为：" + (lineLength / 1000.0).toFixed(3) + "千米";
        } else {
          this.measureDesc =
            "总长度为：" + lineLength.toFixed(1) + "米";
        }

      } else if (itemType === DrawGeometryType.polygon) {
        drawItemDefaultName = "面标注";
        this.titleName = "面标注";

        let pynArea = this.curDrawItem.getArea();
        if (pynArea > 1000000) {
          this.measureDesc =
            "总面积为：" + (pynArea / 1000000).toFixed(3) + "平方千米";
        } else {
          this.measureDesc =
            "总面积为：" + pynArea.toFixed(1) + "平方米";
        }
        
      }

      if (!this.curDrawItem.name) {
        this.drawItemName = drawItemDefaultName;
      } else {
        this.drawItemName = this.curDrawItem.name;
      }

      this.drawItemRemark = this.curDrawItem.remark;
    }
  }
};
</script>


<style lang="scss" scoped>
.info_container {
  cursor: default;
  width: 330px;
}

.title {
  font-weight: 700;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  padding: 5px 0;
}

.edit_label_name {
  float: left;
  width: 40px;
  font-weight: 700;
  font-size: 12px;
  line-height: 24px;
}

.edit_label_remark {
  float: left;
  width: 40px;
  font-weight: 700;
  font-size: 12px;
  line-height: 46px;
}

.edit_textarea {
  padding: 2px 5px;
  font-size: 12px;
  line-height: 20px;
  border: 1px solid #ccc;
  display: block;
  width: 260px;
  border-radius: 3px;
  outline: none;
}

.edit_content_item {
  margin-top: 10px;
}

.edit_btn_group {
  text-align: center;
  margin-top: 10px;
  line-height: 24px;

  a {
    font-size: 12px;
    line-height: 24px;
    padding: 0 10px;
    color: #fff;
    text-decoration: none;
    border: 1px solid #2f87eb;
    display: inline-block;
    border-radius: 1px;
    margin-left: 5px;
    background: #2f87eb;
  }
}
</style>